module.exports = __webpack_public_path__ + "au.svg?bb307e7fab6969ba6d3ff7d2ceeb6288";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/au.svg
// module id = 1234
// module chunks = 0